(() => {
  const mobileViewport = window.matchMedia('(max-width: 768px)');

  function initializeMobileMenu() {
    document.querySelectorAll('.header__navigation').forEach((header) => {
      if (header.dataset.mobileMenuReady === 'true') return;

      const menu = header.querySelector('[data-menu]');
      const burger = header.querySelector('[data-burger]');
      if (!menu || !burger) return;

      header.dataset.mobileMenuReady = 'true';

      const closeSubmenus = () => {
        menu.querySelectorAll('.sub-menu-wrapper--open').forEach((submenu) => {
          submenu.classList.remove('sub-menu-wrapper--open');
        });
        menu.querySelectorAll('.menu-mobile-item.submenu-open').forEach((item) => {
          item.classList.remove('submenu-open');
        });
        menu.querySelectorAll('.btn-sub-menu[aria-expanded="true"]').forEach((button) => {
          button.setAttribute('aria-expanded', 'false');
        });
        menu.querySelectorAll('.sub-menu-list-products--expanded').forEach((list) => {
          list.classList.remove('sub-menu-list-products--expanded');
        });
        menu.querySelectorAll('.sub-menu-item-drop-btn--expanded').forEach((button) => {
          button.classList.remove('sub-menu-item-drop-btn--expanded');
          button.setAttribute('aria-expanded', 'false');
        });
      };

      const setMenuOpen = (open) => {
        menu.classList.toggle('menu--active', open);
        burger.classList.toggle('burger--active', open);
        burger.setAttribute('aria-expanded', String(open));
        burger.setAttribute('aria-label', open ? burger.dataset.closeLabel : burger.dataset.openLabel);
        document.body.classList.toggle('mobile-menu-open', open);
        if (!open) closeSubmenus();
      };

      burger.addEventListener('click', () => {
        if (!mobileViewport.matches) return;
        setMenuOpen(!menu.classList.contains('menu--active'));
      });

      menu.querySelectorAll('.sub-menu-item-drop-btn').forEach((button) => {
        const list = button.closest('.sub-menu-item-products')?.querySelector('.sub-menu-list-products');
        const expanded = Boolean(list?.classList.contains('sub-menu-list-products--expanded'));
        button.classList.toggle('sub-menu-item-drop-btn--expanded', expanded);
        button.setAttribute('aria-expanded', String(expanded));
      });

      menu.addEventListener('click', (event) => {
        if (!mobileViewport.matches) return;

        const backButton = event.target.closest('.sub-menu-back');
        if (backButton && menu.contains(backButton)) {
          event.preventDefault();
          const submenu = backButton.closest('.sub-menu-wrapper');
          const item = backButton.closest('.menu-mobile-item');
          submenu?.classList.remove('sub-menu-wrapper--open');
          item?.classList.remove('submenu-open');
          item?.querySelectorAll('.btn-sub-menu').forEach((button) => {
            button.setAttribute('aria-expanded', 'false');
          });
          return;
        }

        const productToggle = event.target.closest('.sub-menu-item-drop-btn');
        if (productToggle && menu.contains(productToggle)) {
          const list = productToggle.closest('.sub-menu-item-products')?.querySelector('.sub-menu-list-products');
          if (!list) return;
          event.preventDefault();
          const expanded = !list.classList.contains('sub-menu-list-products--expanded');
          list.classList.toggle('sub-menu-list-products--expanded', expanded);
          productToggle.classList.toggle('sub-menu-item-drop-btn--expanded', expanded);
          productToggle.setAttribute('aria-expanded', String(expanded));
          return;
        }

        const submenuTrigger = event.target.closest('.btn-sub-menu');
        if (submenuTrigger && menu.contains(submenuTrigger)) {
          const item = submenuTrigger.closest('.menu-mobile-item');
          const submenu = item?.querySelector(':scope > .sub-menu-wrapper');
          if (!submenu) return;
          event.preventDefault();
          const open = !submenu.classList.contains('sub-menu-wrapper--open');
          item.querySelectorAll('.sub-menu-wrapper--open').forEach((element) => {
            element.classList.remove('sub-menu-wrapper--open');
          });
          item.querySelectorAll('.btn-sub-menu').forEach((button) => {
            button.setAttribute('aria-expanded', String(open));
          });
          submenu.classList.toggle('sub-menu-wrapper--open', open);
          item.classList.toggle('submenu-open', open);
          return;
        }

        if (event.target.closest('a[href]')) setMenuOpen(false);
      });

      header.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && menu.classList.contains('menu--active')) {
          setMenuOpen(false);
          burger.focus();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeMobileMenu, { once: true });
  } else {
    initializeMobileMenu();
  }

  document.addEventListener('shopify:section:load', initializeMobileMenu);
})();
